/**
 * A "no op" function that does absolutely nothing (think IEFBR14 :-)
 */
export default function noOp() {
}
